import React from 'react';
import { Container, Button } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import './style.scss';

const HomepageTakeoverHeader = ({ onClose }) => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  return (
    <div className="HomepageTakeoverHeader">
      <header>
        <Container className="Header__container">
          <div className="Header">
            <div className="Header__logo">
              <CoreLink to={`/${currentLanguage}`}>
                <div className={`Header__logo__img ${currentLanguage === 'nl' ? 'nl-logo' : ''}`} />
              </CoreLink>
            </div>
            <div className="Header__button">
              <Button onClick={onClose} className="Button Button--header--secondary">
                {t('general.to_homepage')}
              </Button>
            </div>
          </div>
        </Container>
      </header>
    </div>
  );
};

export default HomepageTakeoverHeader;
